export function usedAmountRatioVariant(ratio) {
    if (typeof ratio !== "number" || Number.isNaN(ratio)) {
        return 'light'
    }

    if (ratio > 0.75) {
        return "danger";
    }

    if (ratio > 0.5) {
        return "warning";
    }

    return "success";
}

export function daysPastDueVariant(value) {
    if (typeof value !== "number" || Number.isNaN(value)) {
        return 'light'
    }
    if (value > 30) {
        return "dark";
    }

    if (value > 10) {
        return "danger";
    }

    if (value > 0) {
        return "warning";
    }

    return "success";
}
